import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Form, Select, DatePicker, Radio, Button } from 'antd';
import moment from 'moment';
import http from '../../../Http';
import utils from '../../../utils';
import ReactECharts from 'echarts-for-react';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/date-picker/locale/zh_CN';
import en_US from 'antd/lib/date-picker/locale/en_US';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';


const energyOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(energyOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        data: [],
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            type: 'bar',
        }
    ]
}

function EnergyStatisticsUhomeSinglePhase(props) {
    const { t, i18n } = useTranslation();
    const { Timezone, inverterSelectOptions, SN, model, protocol, handleSelectSN } = props
    const [reportData, setReportData] = useState(null)
    const setTip = useContext(utils.tipContext)

    const [date, setDate] = useState(moment().format('YYYY-MM-DD')) //时间
    const [size, setSize] = useState('month')  //月, 年, 总计
    const [active, setActive] = useState(0)

    const energyChart = useRef(null)

    const exportToExcel =  useCallback(() => {
        console.log(energyOption);
        if (energyOption.series[0].data == null || energyOption.series[0].data.length == 0) {
            return;
        }

        let dtStr = moment(date).format('YYYY-MM');
        let rs = 
        energyOption.series[0].data.map((v, i) => {
            let r = {}; 
            if (size === 'month') {
                r[t("DataTime")] = dtStr + "-" + (i + 1).toString().padStart(2, '0');
                r[t("Energy")] = v;
            } else if (size === 'year') {
                r[t("DataTime")] = dtStr.substring(0, 4) + "-" + (i + 1).toString().padStart(2, '0');
                r[t("Energy")] = v;
            } else if (size === 'total') {
                r[t("DataTime")] = i + 1;
                r[t("Energy")] = v;
            }
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        let fileName = active === 0 ? t('E_pv') :
            active === 1 ? t('E_charge') :
            active === 2 ? t('E_discharge') :
            active === 3 ? t('EnergyToGrid') :
            active === 4 ? t('EnergyFromGrid') :
            active === 5 ? t('E_eps') :
            active === 6 ? t('EnergyToLoad') :
            "";
        let ym = size === 'month' ? "_"+moment(date).format('YYYYMM') :
            size === 'year' ? "_"+moment(date).format('YYYY') :
            "";
        XLSX.writeFile(wb, SN + '_' + fileName + ym + ".xlsx");
    }, [ SN, active, size, t]);
    energyOption.toolbox.feature.myDownloadXls.onclick = exportToExcel;

    //获取月, 年, 总体数据
    useEffect(() => {
        if (!SN) return;
        let active = true;
        let url = 'integrated-inverter/uhome-singlephase/report/' +
            (size === 'month' ? 'monthly' : size === 'year' ? 'yearly' : 'all-years') +
            '/report';
        //取数据
        (async () => {
            let resp = await http.post(url, {
                SerialNumber: SN,
                Date: size === 'month' ? moment(date).format('YYYY-MM') : size === 'year' ? moment(date).format('YYYY') : ''    
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });
            if (!active) {
                return;
            }
            if (resp === null || resp.code !== 200) {  //请求数据失败
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter record error") });
                return;
            } else {  //请求数据成功
                setReportData(resp.data)
            }
        })();

        return () => {
            active = false;
        };

    }, [SN, size, date, t]);

    //draw Chart
    useEffect(() => {
        if (!reportData) {
            energyOption.xAxis.data = []
            energyOption.series[0].data = []
        } else {
            if (size === 'month') {  //绘制月数据
                //坐标, 计算每个月有多少天
                const y = moment(date).year()
                const m = moment(date).month()
                let days = Array(new Date(y, m + 1, 0).getDate())
                days.fill(0).forEach((v, i) => {
                    days[i] = i + 1;
                })
                energyOption.xAxis.data = days;
                //坐标
                const yData = Array(days.length).fill(0)
                reportData.forEach(v => {
                    yData[moment(v['CreateTime']).date() - 1] =
                        active === 0 ? (v['EDayPV']*0.01).toFixed(2) :
                        active === 1 ? (v['EDayToGrid']*0.01).toFixed(2) :
                        active === 2 ? (v['EDayLoad']*0.01).toFixed(2) :
                            null;
                })
                //Echart坐标数据
                energyOption.series[0] =
                    active === 0 ? { ...energyOption.series[0], name: t('E_pv'), data: yData } :
                    active === 1 ? { ...energyOption.series[0], name: t('E_ToGrid'), data: yData } :
                    active === 2 ? { ...energyOption.series[0], name: t('E_Load'), data: yData } :
                        null;
            } else if (size === 'year') {  //绘制年数据
                //坐标
                energyOption.xAxis.data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                const yData = Array(12).fill(0)
                reportData.forEach(v => {
                    yData[moment(v['CreateTime']).month()] =
                        active === 0 ? (v['EMonthPV']*0.01).toFixed(2) :
                        active === 1 ? (v['EMonthToGrid']*0.01).toFixed(2) :
                        active === 2 ? (v['EMonthLoad']*0.01).toFixed(2) :
                            null;
                })
                //Echart坐标数据
                energyOption.series[0] =
                    active === 0 ? { ...energyOption.series[0], name: t('E_pv'), data: yData } :
                    active === 1 ? { ...energyOption.series[0], name: t('E_ToGrid'), data: yData } :
                    active === 2 ? { ...energyOption.series[0], name: t('E_Load'), data: yData } :
                        null;
            } else { //绘制总体数据
                //坐标
                const curYear = new Date().getFullYear()
                let days = Array(10).fill(0)
                days.fill(0).forEach((v, i) => {
                    days[i] = curYear - 9 + i
                })
                energyOption.xAxis.data = days;
                const yData = Array(10)
                reportData.forEach(v => {
                    yData[moment(v['Y']).year() - curYear + 9] =
                        active === 0 ? (v['EYearPV']*0.01).toFixed(2) :
                        active === 1 ? (v['EYearToGrid']*0.01).toFixed(2) :
                        active === 2 ? (v['EYearLoad']*0.01).toFixed(2) :
                            null;
                })
                //Echart坐标数据
                energyOption.series[0] =
                    active === 0 ? { ...energyOption.series[0], name: t('E_pv'), data: yData } :
                    active === 1 ? { ...energyOption.series[0], name: t('E_ToGrid'), data: yData } :
                    active === 2 ? { ...energyOption.series[0], name: t('E_Load'), data: yData } :
                        null;
            }
        }

        //渲染数据到页面
        const instance = energyChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(energyOption, true);
        }
    }, [reportData, active, t])

    return (
        <div className="energy-statistics">
            <div className="energy-statistics-header">
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t('Enter Inverter Name')}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => handleSelectSN(value, option)}
                    value={SN}
                    style={{ width: '200px', marginRight: '20px' }}
                >{inverterSelectOptions}</Select>
                <Radio.Group value={size} optionType='button' buttonStyle='solid' onChange={e => setSize(e.target.value)} style={{ marginRight: '10px' }}>
                    <Radio.Button value="month">{t('Month')}</Radio.Button>
                    <Radio.Button value="year">{t('Year')}</Radio.Button>
                    <Radio.Button value="total">{t('Total')}</Radio.Button>
                </Radio.Group>
                {size !== 'total' ?
                    <DatePicker
                        picker={size === "month" ? 'month' : 'year'}
                        onChange={(_, ds) => setDate(ds)}
                        defaultValue={moment()}
                        value={moment(date)}
                        allowClear={false}
                        locale={i18n.language === 'zh' ? zh_CN : en_US}
                    /> : null}
            </div>
            <div className="energy-statistics-main">
                <div className="side">
                    <div className="title">{t('Energy')}</div>
                    <div className="item">
                        <ul>
                            <li className={active === 0 ? 'active' : null} onClick={() => setActive(0)}>{t('E_pv')}(kWh)</li>
                            <li className={active === 1 ? 'active' : null} onClick={() => setActive(1)}>{t('E_ToGrid')}(kWh)</li>
                            <li className={active === 2 ? 'active' : null} onClick={() => setActive(2)}>{t('E_Load')}(kWh)</li>
                        </ul>
                    </div>
                </div>
                <div className="box">
                    <div className="title">
                        {active === 0 ? t('E_pv') + '(kWh)' :
                            active === 1 ? t('E_ToGrid') + '(kWh)' :
                                active === 2 ? t('E_Load') + '(kWh)' :
                                    null
                        }
                        -
                        {size === 'month' ? '(' + (SN || '') + ', ' + moment(date).format('YYYY-MM') + ')' :
                            size === 'year' ? '(' + (SN || '') + ', ' + moment(date).format('YYYY') + ')' :
                                '(' + (SN || '') + ')'}
                    </div>
                    <div className="chart">
                        <ReactECharts ref={energyChart} option={energyOption} style={{ height: 500 }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnergyStatisticsUhomeSinglePhase;